import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken, usePropertyField, EditableToken } from '@vibesites/runtime/react';
import { resolvedThemePages } from '../theme-pages';

const allPages = resolvedThemePages
  .filter((p) => p.path !== '/sitemap' && !p.path.includes('{{'))
  .sort((a, b) => a.position - b.position);

export function SitemapContent() {
  const applyNowUrl = useContentToken('sitemapContent.apply_now_url') as string | null;

  // Conditionally show "Interactive Map" link only when custom_engrain_sightmap_url exists
  const engrainSightmapUrl = usePropertyField('custom_engrain_sightmap_url') as string | null | undefined;
  const hasInteractiveMap = !!engrainSightmapUrl && engrainSightmapUrl !== 'false';

  const pages = hasInteractiveMap
    ? allPages
    : allPages.filter((p) => p.path !== '/interactive-map');

  return (
    <section className="py-16 md:py-24 bg-[var(--vibe-color-background)]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          {pages.map((page) => {
            // For the Apply Now page, link to the external property_apply_now_url
            const isApplyNow = page.path === '/apply-now';
            const href = isApplyNow && applyNowUrl ? applyNowUrl : page.path;
            const target = isApplyNow && applyNowUrl ? '_blank' : undefined;
            const rel = isApplyNow && applyNowUrl ? 'noopener noreferrer' : undefined;

            const anchor = (
              <a
                key={page.path}
                href={href}
                target={target}
                rel={rel}
                className="block border border-[var(--vibe-color-border)] rounded px-6 py-4 text-center font-body text-sm text-[var(--vibe-color-secondary)] hover:text-[var(--vibe-color-primary)] hover:border-[var(--vibe-color-primary)] transition-colors"
              >
                {page.name}
              </a>
            );

            if (isApplyNow) {
              return (
                <EditableToken key={page.path} path="sitemapContent.apply_now_url" type="url" label="Apply Now URL">
                  {anchor}
                </EditableToken>
              );
            }

            return anchor;
          })}
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SitemapContent',
  displayName: 'Sitemap',
  tokens: {
    'sitemapContent.apply_now_url': {
      label: 'Apply Now URL',
      type: 'url',
      defaultField: 'property_apply_now_url',
    },
  },
};

(SitemapContent as any).contentSchema = contentSchema;

export default SitemapContent;
